import React from 'react';

import cls from '@widgets/Files/UI/FileFolder/ui/FileFolder.module.css';

interface IFileFolderIconProps {
    previewSvgUrl: string;
    width?: number;
    height?: number;
}

export const FolderIcon = ({ previewSvgUrl, width = 90, height = 90 }: IFileFolderIconProps) => (
    <div className={cls.iconWrapper}>
        <img
            src={previewSvgUrl}
            alt="folder preview"
            height={height}
            width={width}
            draggable={false}
        />
    </div>
);
